module.exports = __webpack_public_path__ + "static/img/2.506d5eb4.jpg";